import { Form, Formik } from 'formik';
import { useMemo, useCallback, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import Deployment from '../../services/deployment';
import GenericDropdown from '../controls/GenericDropdown';

const DeploymentSelector = ({
    environments,
    envHeading,
    deploymentHeading,
    onDeploymentSelect,
    exclude = '',
    setAllDeployments,
}) => {
    const [translate] = useTranslation();
    const [selectedEnvironmentId, setSelectedEnvironmentId] = useState('');
    const [deployments, setDeployments] = useState([]);

    const getDeployments = useCallback(async (environmentId) => {
        const response = await Deployment.getAllDeploymentsInEnvironment(environmentId);
        if (!response.error) {
            setAllDeployments && setAllDeployments(response.data);
            if (exclude) {
                setDeployments(response.data.filter(el => el._id !== exclude));
            }
            else {
                setDeployments(response.data);
            }
        }
    }, [setAllDeployments, exclude]);

    useEffect(() => {
        if (selectedEnvironmentId) {
            getDeployments(selectedEnvironmentId);
        }
    }, [selectedEnvironmentId, getDeployments]);

    const renderForm = useMemo(() => (
        <>
            <GenericDropdown
                options={environments}
                valueKey='_id'
                displayValueKey='name'
                heading={translate(envHeading)}
                onSelect={(id) => setSelectedEnvironmentId(id)}
            />
            <div className='mt-3'>
                <GenericDropdown
                    options={deployments}
                    valueKey='_id'
                    displayValueKey='name'
                    heading={translate(deploymentHeading)}
                    onSelect={(id) => onDeploymentSelect(id)}
                />
            </div>
        </>

    ), [environments, translate, onDeploymentSelect, envHeading, deploymentHeading, deployments]);

    return (
        <Formik initialValues={{
            deployments
        }} enableReinitialize>
            <Form>
                {renderForm}
            </Form>
        </Formik>
    );
};

export default DeploymentSelector;